// extracted by mini-css-extract-plugin
export var lg = "_1m-4";
export var md = "_1m-3";
export var sm = "_1m-2";
export var xs = "_1m-1";
export var xxs = "_1m-0";